import { createContext, FC, ReactNode, useEffect, useState } from 'react'
import { getFeaturesConfigurationByStoreId } from '../../../../../domain/resource-management/resource-management.services'

interface FeaturesConfigurationContextProps {
  canUpdateTaskOptimals: boolean
  getCanUpdateTaskOptimals: (storeId: string) => void
}

const FeaturesConfigurationContext = createContext<FeaturesConfigurationContextProps>({
  canUpdateTaskOptimals: false,
  getCanUpdateTaskOptimals: () => false
})

interface FeaturesConfigurationProviderProps {
  children: ReactNode
}

const FeaturesConfigurationProvider: FC<FeaturesConfigurationProviderProps> = ({ children }) => {
  const [canUpdateTaskOptimals, setCanUpdateTaskOptimals] = useState<boolean>(false)

  useEffect(() => {
    return () => {
      setCanUpdateTaskOptimals(false)
    }
  }, [])

  const getCanUpdateTaskOptimals = async (storeId: string) => {
    const response = await getFeaturesConfigurationByStoreId(storeId)
    setCanUpdateTaskOptimals(response?.features?.[0]?.value?.enabled ?? false)
  }

  return (
    <FeaturesConfigurationContext.Provider value={{ canUpdateTaskOptimals, getCanUpdateTaskOptimals }}>
      {children}
    </FeaturesConfigurationContext.Provider>
  )
}

export { FeaturesConfigurationContext, FeaturesConfigurationProvider }
